import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';

const FranchiseFixedFeeThresholdField: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	return (
		<FullInfoField
			label="franchiseFixedFeeThresholdLabel"
			value={restaurantForFullInfo?.vivaWalletIsv?.franchiseCommission?.fixedAmountThreshold}
		/>
	);
};

export default FranchiseFixedFeeThresholdField;
